import { render, staticRenderFns } from "./FWDTargetSettings.vue?vue&type=template&id=268ec51e"
import script from "./FWDTargetSettings.vue?vue&type=script&lang=js"
export * from "./FWDTargetSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports